import { snakeCase, toUpper } from 'lodash';

export const selectedPeriodActionBase = 'SELECTED_PERIOD_';
export const selectedCustomToDateActionBase = 'SELECTED_TO_CUSTOM_DATE_';
export const selectedCustomFromDateActionBase = 'SELECTED_FROM_CUSTOM_DATE_';
export const toggledCustomDateActionBase = 'TOGGLED_CUSTOM_DATE_';
export const selectedAccountTypeActionBase = 'SELECTED_ACCOUNT_TYPE_';

export const buildActionTypeForFilterType = (base, filterType) => {
  const suffix = toUpper(snakeCase(filterType));
  return base + suffix;
};

// Name helpers
export const getSelectedPeriodActionForFilterType = (filterType) =>
  buildActionTypeForFilterType(selectedPeriodActionBase, filterType);
export const getSelectedCustomFromDateActionForFilterType = (filterType) =>
  buildActionTypeForFilterType(selectedCustomFromDateActionBase, filterType);
export const getSelectedCustomToDateActionForFilterType = (filterType) =>
  buildActionTypeForFilterType(selectedCustomToDateActionBase, filterType);
export const getToggledCustomDateActionForFilterType = (filterType) =>
  buildActionTypeForFilterType(toggledCustomDateActionBase, filterType);
export const getSelectedAccountTypeActionForFilterType = (filterType) =>
  buildActionTypeForFilterType(selectedAccountTypeActionBase, filterType);

// Action creators
export const selectedPeriod = (period, filterType) => ({
  type: buildActionTypeForFilterType(selectedPeriodActionBase, filterType),
  period
});

export const selectedCustomFromDate = (fromDate, filterType) => ({
  type: buildActionTypeForFilterType(
    selectedCustomFromDateActionBase,
    filterType
  ),
  fromDate
});

export const selectedCustomToDate = (toDate, filterType) => ({
  type: buildActionTypeForFilterType(
    selectedCustomToDateActionBase,
    filterType
  ),
  toDate
});

export const toggledCustomDate = (custom, filterType) => ({
  type: buildActionTypeForFilterType(toggledCustomDateActionBase, filterType),
  custom
});

export const selectedAccountType = (accountTypeFilterSelection, filterType) => {
  /**
   *  type"SELECTED_ACCOUNT_TYPE_PORTFOLIO_GROWTH"
      accountTypeFilterSelection:"Non-Retirement"
      filterType:"portfolioGrowth"
   */
  return {
    type: getSelectedAccountTypeActionForFilterType(filterType),
    accountTypeFilterSelection,
    filterType
  };
};

export const RESET_FILTERS_FOR_ACCOUNT_DETAILS =
  'RESET_FILTERS_FOR_ACCOUNT_DETAILS';
export const resetFiltersForAccountDetails = () => ({
  type: RESET_FILTERS_FOR_ACCOUNT_DETAILS
});

export const RESET_FILTERS_FOR_PERFORMANCE = 'RESET_FILTERS_FOR_PERFORMANCE';
export const resetFiltersForPerformance = () => ({
  type: RESET_FILTERS_FOR_PERFORMANCE
});
